import { userProfileRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const userProfileRoute: RouteObject = {
  path: userProfileRoutePaths.main.path,
  async lazy() {
    const UserProfilePage = await import('@/pages/user-profile/UserProfilePage');
    return { Component: UserProfilePage.default };
  },
};
